// Real customer testimonials provided by the owner
export const reviews = [
  {
    id: "r1",
    author: "Sarah J.",
    initials: "SJ",
    origin: "Portimão",
    quote:
      "The steak on stone was so good we drove from Portimão just to have it again. Tender, juicy, and perfect!",
  },
  {
    id: "r2",
    author: "Mark T.",
    initials: "MT",
    origin: "Vilamoura",
    quote:
      "Finest curry around Vilamoura. The house wine and the cozy atmosphere make it a hidden gem.",
  },
  {
    id: "r3",
    author: "David R.",
    initials: "DR",
    origin: "Marina Guest",
    quote:
      "A lovely escape from the Marina's hustle. The live music nights on the terrace are the highlight of our trip.",
  },
  {
    id: "r4",
    author: "Michelle W.",
    initials: "MW",
    origin: "Algarve",
    quote:
      "Best homemade apple pie in the Algarve! Friendly staff that makes you feel like family.",
  },
];
